export const TEXT_COLOR = '#212325'
export const COLD_BG = '#EAF2FB'
export const WARM_BG = '#FFEAEC'

/** Shared transition timings (cold ↔ warm) */
export const MOTION_MS = {
  contentExit: 400,
  scene: 700,
  contentEnter: 500,
  particleMorph: 750,
}
